import React, {useEffect} from "react";
import { Link } from "react-router-dom";
import axios from "../../api/axiosInstance";

const SubscriptionCancel: React.FC = () => {
    useEffect(() => {
        const cancelPendingUpgrade = async () => {
            try {
                await axios.post("/subscription/cancel-checkout");
                console.log("✅ Pending upgrade cleared.");
            } catch (err) {
                console.error("❌ Failed to clear pending upgrade:", err);
            }
        };
        cancelPendingUpgrade();
    }, []);

    return (
        <div className="min-h-screen flex items-center justify-center bg-red-50 px-6">
            <div className="bg-white shadow-lg rounded-lg p-10 max-w-lg text-center animate-fade-in-up">
                <div className="flex justify-center mb-6">
                    <div className="bg-red-100 rounded-full p-4 animate-pulse">
                        <span className="text-red-600 text-4xl">❌</span>
                    </div>
                </div>
                <h1 className="text-3xl font-bold text-red-700 mb-4">Subscription Canceled</h1>
                <p className="text-gray-600 mb-6">
                    You canceled the checkout process. No worries — you can select a plan whenever you're ready.
                </p>
                <Link to="/subscription">
                    <button className="bg-red-600 hover:bg-red-700 text-white font-medium px-6 py-2 rounded-lg transition">
                        Back to Plans
                    </button>
                </Link>
            </div>
        </div>
    );
};

export default SubscriptionCancel;
